import { FC } from 'react';
import { useTranslation, TextLinkStyle, TextLink, IconStyle, FAIcon, Shade, Theme } from '@nextgen-web-framework/all';
import type { AddressBookDisplayTestProps } from './types/propTypes';
import styles from './AddNewAddressDisplayText.module.scss';

const AddNewAddressDisplayText: FC<AddressBookDisplayTestProps> = ({ onTextlinkClick, isInsideDrawer, buttonText }) => {
  const t = useTranslation();
  return (
    <div
      className={`${styles['add-new-address-container']} ${
        isInsideDrawer ? styles['add-new-address-container-inside-drawer'] : ''
      }`}
    >
      <FAIcon
        className="verified_icon"
        theme={Theme.BLACK}
        iconName={'plus'}
        shade={Shade.DARK}
        iconStyle={IconStyle.SOLID}
      />
      <span className={styles['add-new-address-text']}>
        <TextLink
          id="add-new-address-btn"
          data-testid="add-new-address-btn"
          text={buttonText ?? t('profile.addNewAddress.heading')}
          textLinkStyle={TextLinkStyle.UNDERLINE}
          onClick={() => {
            onTextlinkClick?.();
          }}
          href="#"
        />
      </span>
    </div>
  );
};
export default AddNewAddressDisplayText;
